"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _core = require("./core");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["classes"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".ca898f704{position:relative}.c33414203{position:absolute;display:flex;align-items:center;top:0;bottom:0;left:.4375rem;color:var(--color-gray-80)}.c97f7d114{font-family:inherit;outline:0;border:none;background:#fff;width:calc(100% - .4375rem * 2);box-sizing:content-box;font-size:.875rem;font-weight:500;line-height:1.25rem;padding:.25rem .4375rem;box-shadow:0 1px 1px rgba(0,0,0,.08),0 0 0 1px rgba(42,47,69,.16);border-radius:.25rem;color:var(--color-gray-90)}.c97f7d114::-webkit-input-placeholder{color:var(--color-gray-40)}.c97f7d114:-ms-input-placeholder{color:var(--color-gray-40)}.input::-webkit-input-placeholder{color:var(--color-gray-40)}.input:-ms-input-placeholder{color:var(--color-gray-40)}.c97f7d114::placeholder{color:var(--color-gray-40)}.c97f7d114:not(.c1552ccd5):focus{box-shadow:0 1px 1px rgba(0,0,0,.08),0 0 0 4px rgba(58,151,212,.36)}.c8ab00473{visibility:visible}.c1552ccd5{color:var(--color-gray-40);box-shadow:0 0 0 1px rgba(42,47,69,.08)}.ca0123cb1{resize:none}.c0f63bbdf{width:calc(100% - 1rem * 2);padding:.625rem 1rem}.c4bc970f3{padding-left:1.8125rem;width:calc(100% - .4375rem - 1.8125rem)}.c4bc970f3.c0f63bbdf{width:calc(100% - 1rem - 1.8125rem)}.c6adfc935{background:var(--color-gray-10);box-shadow:none}");
var styles = {
  root: 'ca898f704',
  icons: 'c33414203',
  input: 'c97f7d114',
  '--disabled': 'c1552ccd5',
  '--warning': 'c8ab00473',
  '--textarea': 'ca0123cb1',
  '--tall': 'c0f63bbdf',
  '--with-icon': 'c4bc970f3',
  '--shaded': 'c6adfc935'
};
var SecondaryInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_core.CoreInput, (0, _extends2.default)({
    ref: ref
  }, rest, {
    cn: cn,
    warning: false
  }));
});
exports.SecondaryInput = SecondaryInput;
SecondaryInput.propTypes = {
  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryInput.defaultProps = {
  classes: {}
};